// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_lS3Kv {
  flex: 1 0 0;
  height: 100% !important;
  min-width: 500px !important;
}

.table_lS3Kv [role='rowgroup'] {
  display: flex;
  flex-flow: column nowrap;
  height: calc(100% - (42px)) !important;
}

.table_lS3Kv [role='columnheader']:first-child {
  width: 95px !important;
  min-width: 95px !important;
  max-width: 95px !important;
}

.table_lS3Kv [role='columnheader']:nth-child(3),
.table_lS3Kv [role='columnheader']:nth-child(4),
.table_lS3Kv [role='columnheader']:nth-child(5) {
  width: 170px !important;
  min-width: 170px !important;
  max-width: 170px !important;
}

.table_lS3Kv [role='cell']:first-child {
  width: 95px !important;
  min-width: 95px !important;
  max-width: 95px !important;
}

.table_lS3Kv [role='cell']:nth-child(3),
.table_lS3Kv [role='cell']:nth-child(4),
.table_lS3Kv [role='cell']:nth-child(5) {
  width: 170px !important;
  min-width: 170px !important;
  max-width: 170px !important;
}

.row_zjTd2 {
  min-height: 70px !important;
}

.table_lS3Kv [role='row']:first-child {
  background-color: var(--color-base050);
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/cycleTimeMonitoring/components/DelayOverviewTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":[".table {\n  flex: 1 0 0;\n  height: 100% !important;\n  min-width: 500px !important;\n}\n\n.table [role='rowgroup'] {\n  display: flex;\n  flex-flow: column nowrap;\n  height: calc(100% - (42px)) !important;\n}\n\n.table [role='columnheader']:first-child {\n  width: 95px !important;\n  min-width: 95px !important;\n  max-width: 95px !important;\n}\n\n.table [role='columnheader']:nth-child(3),\n.table [role='columnheader']:nth-child(4),\n.table [role='columnheader']:nth-child(5) {\n  width: 170px !important;\n  min-width: 170px !important;\n  max-width: 170px !important;\n}\n\n.table [role='cell']:first-child {\n  width: 95px !important;\n  min-width: 95px !important;\n  max-width: 95px !important;\n}\n\n.table [role='cell']:nth-child(3),\n.table [role='cell']:nth-child(4),\n.table [role='cell']:nth-child(5) {\n  width: 170px !important;\n  min-width: 170px !important;\n  max-width: 170px !important;\n}\n\n.row {\n  min-height: 70px !important;\n}\n\n.table [role='row']:first-child {\n  background-color: var(--color-base050);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_lS3Kv`,
	"row": `row_zjTd2`
};
export default ___CSS_LOADER_EXPORT___;
